import React from 'react';
import { FuturevoterEligibleStatement } from '~components/Futurevoter/FuturevoterEligibleContent';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export default function FutureVoterDownloadPDFContent({ ovrLink }) {
  const person = useSelector((state) => state.person);

  return (
    <>
      {!ovrLink && (
        <>
          <FuturevoterEligibleStatement displayGoodNews />
          <p>
            The bad news is that you can&apos;t do this online, so you&apos;re
            going to need to print and mail a form.
          </p>
        </>
      )}
      <ol>
        <li>
          We&apos;ll email your voter registration form to{' '}
          {person.email ? <strong>{`${person.email}`}</strong> : 'you'}. You
          should receive the email within 3 minutes. If you can&apos;t find it,
          check your spam folder.
        </li>
        <li>Fill out all the fields, and sign and date where indicated.</li>
        <li>Mail your form to the address provided.</li>
      </ol>
    </>
  );
}

FutureVoterDownloadPDFContent.propTypes = {
  ovrLink: PropTypes.string,
};
